module.exports = __webpack_public_path__ + "assets/368cbb56b3cff650b028b51457414901.png";